import { Link } from "react-router";

export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="mt-2 text-muted-foreground">This page could not be found.</p>
      <Link to="/" className="mt-4 inline-block text-sm text-primary hover:underline">
        Back to Workspaces
      </Link>
    </div>
  );
}
